import { FC } from 'react';
import { observer } from 'mobx-react';
import { Card, Text } from '@servicetitan/anvil2';
import { TitleWithValueComponent } from './common/title-value';
import classNames from 'classnames';
import { CalculatorDuctSizingResponseDto } from '../../models/calculator-duct-sizing.response.dto';

export const CalculatorDuctSizingAnswer: FC<{
    data: CalculatorDuctSizingResponseDto;
    className?: string;
}> = observer(({ data, className }) => {
    return (
        <Card className={classNames('w-100-i', className)}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr', rowGap: 12 }}>
                <TitleWithValueComponent
                    title="Round sizes"
                    value={
                        <ul style={{ paddingLeft: 16, margin: 8 }}>
                            <li>
                                <Text size="small">
                                    {data.round_sizes.diameter} inch round duct at{' '}
                                    {data.round_sizes.fpm} FPM
                                </Text>
                            </li>
                        </ul>
                    }
                />
                <TitleWithValueComponent
                    title="Rectangular sizes"
                    value={
                        <ul style={{ paddingLeft: 16, margin: 8 }}>
                            {data.rectangular_sizes.map(item => (
                                <li key={`${item.width}x${item.height}x${item.fpm}`}>
                                    <Text size="small">
                                        {item.width} x {item.height} inch duct at {item.fpm} FPM
                                    </Text>
                                </li>
                            ))}
                        </ul>
                    }
                />
            </div>
        </Card>
    );
});
